<script>
  import acessosServico from '../servico';

  export default {
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        carregando: true,


        mostrarCursos : false,
        mostrarEventos : false,
        mostrarServicos : false,
        mostrarDoacoes : true,
        mostrarAlunos : false,
        mostrarFornecedores: false,
        mostrarLicitacoes: true,
      }
    },
    methods: {
    },
    computed: {
    },
    mounted() {
      this.carregando = false;

      this.mostrarCursos = this.configuracao.utilizarCurso;
      this.mostrarEventos = this.configuracao.utilizarEvento;
      this.mostrarServicos = this.configuracao.utilizarServico;
      this.mostrarDoacoes = this.configuracao.utilizarDoacao;
      this.mostrarAlunos = this.configuracao.utilizarAluno;
      this.mostrarFornecedores = this.configuracao.utilizarFornecedor;
      this.mostrarLicitacoes = true;
    }
  }
</script>

<style scoped>

  li {
    background-color:white;
    margin: 15px;
  }

  .container {
    margin-right: auto;
    margin-left: auto;
  }

  ul, ul li {
    padding: 0;
    list-style: none;
    list-style-type: none;
    list-style-image: none;
  }

  .imgBox{
    position:relative;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    width:100%;
  }

  .imgBox img {
    width: 100%;
    height: 195px;
  }

  .imgBox h3 {
      position: absolute;
      bottom: -8px;
      left: 0;
      padding: 15px 20px;
      font-size: .95em;
      color: #fff;
      background-color: #999;
    }
  
  
  .readMore {
    display: block;
    padding: 8px;
    width: 100%;
    text-align: center;
    font-weight: 700;
    color: #fff;
  }

  li {
    margin-left: 5%;
  }

  /*Cursos*/
 
  li.cursos a .imgBox h3 {
    background-color: #1f73a3;
  }

    li.cursos a .readMore {
      background-color: rgba(31,115,163,.6);
      -webkit-transition: all .2s ease-in-out;
      transition: all .2s ease-in-out;
    }

    li.cursos a:hover .readMore {
      background-color: rgba(31,115,163,.8);
    }
  
  /* Eventos */

  li.eventos a .imgBox h3{
    background-color:#952638;
  }

  li.eventos  a  .readMore {
    background-color: rgba(149,38,56,.6);
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
  }

  li.eventos a:hover .readMore {
    background-color: rgba(149,38,56,.8);
  }

  /* Serviços */

  li.servicos a .imgBox h3 {
    background-color: #fe6847;
  }

  li.servicos a .readMore {
    background-color: rgba(254,104,71,.6);
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
  }

  li.servicos a:hover .readMore {
    background-color: rgba(254,104,71,.8);
  }
  
  /* Doações */

  li.doacoes a .imgBox h3{
    background-color:#1094ab;
  }

  li.doacoes a .readMore {
    background-color: rgba(16,148,171,.6);
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
  }

  li.doacoes a:hover .readMore {
    background-color: rgba(16,148,171,.8);
  }

  /* Alunos */

  li.alunos a .imgBox h3{
    background-color:#b66d0d;
  }

  li.alunos a .readMore {
    background-color: rgba(182,109,13,.6);
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out
  }

  li.alunos a:hover .readMore {
    background-color: rgba(182,109,13,.8);
  }

  /* Fornecedores */

  li.fornecedores a .imgBox h3{
    background-color:#118815;
  }

  li.fornecedores a .readMore {
    background-color: rgba(17,136,21,.6);
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out
  }

    li.fornecedores a:hover .readMore {
      background-color: rgba(17,136,21,.8);
    }

    /* Licitações */

    li.licitacoes a .imgBox h3 {
      background-color: rgba(254,104,71,.6);
    }

    li.licitacoes a .readMore {
      background-color: rgba(254,104,71,.6);
      -webkit-transition: all .2s ease-in-out;
      transition: all .2s ease-in-out
    }

    li.licitacoes a:hover .readMore {
      background-color: rgba(254,104,71,.6);
    }

</style>

<template>
  <div class="container" style="padding-top: 80px;" v-if="!carregando">
    <ul class="row">
      <li class="col-12 col-sm-6 col-md-3 alunos" v-if="mostrarAlunos">
        <router-link active-class=""
                     :to="{ name: 'login.aluno' }">
          <div class="imgBox">
            <img src="img/acesso/atalhos/alunos.jpg" alt="Alunos" class="default img-fluid">

            <h3>Alunos</h3>
          </div>

          <div class="readMore">
            Acessar
          </div>
        </router-link>
      </li>

      <li class="col-12 col-sm-6 col-md-3 cursos" v-if="mostrarCursos">
        <router-link active-class=""
                     :to="{ name: 'acessos.cursos' }">
          <div class="imgBox">
            <img src="img/acesso/atalhos/cursos.jpg" alt="Cursos" class="default img-fluid">

            <h3>Cursos</h3>
          </div>

          <div class="readMore">
            Acessar
          </div>
        </router-link>
      </li>

      <li class="col-12 col-sm-6 col-md-3 doacoes" v-if="mostrarDoacoes">
        <router-link active-class=""
                     :to="{ name: 'acessos.doacoes' }">
          <div class="imgBox">
            <img src="img/acesso/atalhos/doacoes.jpg" alt="Doações" class="default img-fluid">

            <h3>Doações</h3>
          </div>

          <div class="readMore">
            Acessar
          </div>
        </router-link>
      </li>

      <li class="col-12 col-sm-6 col-md-3 eventos" v-if="mostrarEventos">
        <router-link active-class=""
                     :to="{ name: 'acessos.eventos' }">
          <div class="imgBox">
            <img src="img/acesso/atalhos/eventos.jpg" alt="Eventos" class="default img-fluid">

            <h3>Eventos</h3>
          </div>

          <div class="readMore">
            Acessar
          </div>
        </router-link>
      </li>

      <li class="col-12 col-sm-6 col-md-3 fornecedores" v-if="mostrarFornecedores">
        <router-link active-class=""
                     :to="{ name: 'login.fornecedor' }">
          <div class="imgBox">
            <img src="img/acesso/atalhos/fornecedores.jpg" alt="fornecedores" class="default img-fluid">

            <h3>Fornecedores</h3>
          </div>

          <div class="readMore">
            Acessar
          </div>
        </router-link>
      </li>

      <li class="col-12 col-sm-6 col-md-3 servicos" v-if="mostrarServicos">
        <router-link active-class=""
                     :to="{ name: 'acessos.servicos' }">
          <div class="imgBox">
            <img src="img/acesso/atalhos/servicos.jpg" alt="Serviços" class="default img-fluid">

            <h3>Serviços</h3>
          </div>

          <div class="readMore">
            Acessar
          </div>
        </router-link>
      </li>

      <li class="col-12 col-sm-6 col-md-3 licitacoes" v-if="mostrarLicitacoes">
        <router-link active-class=""
                     :to="{ name: 'acessos.licitacoes' }">
          <div class="imgBox">
            <img src="img/acesso/atalhos/licitacoes.jpg" alt="Licitações" class="default img-fluid">

            <h3>Licitações</h3>
          </div>

          <div class="readMore">
            Acessar
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/AcessosPaginaPrincipal.vue